#### Webhook security enhancements

On the 14th of April 2025, webhooks will be updated with the following security enhancements:

**Mandatory webhook signing**

Webhook signing will be mandatory for all new and updated webhook subscriptions.
[Creating] and [updating] a webhook subscription will now require a [`secret`] to be provided and the [`signingAlgorithmCode`] to be set to `SeekHmacSha512`.

Verify the webhook payload was not tampered with during transit via its signature to prevent spoofing attacks.
See [webhook security] for more information on validating payloads.

**New `expireDateTime` field**

A new `expireDateTime` field will be added to [webhook payloads].
This field will contain the timestamp when the webhook payload expires.

Verify the freshness of the webhook payload via its expiry timestamp to prevent replay attacks.
Discard the event if its timestamp is in the past as that indicates that the request was not sent directly from the SEEK API.
See [webhook security] for more information on validating payloads.

[Webhook Security]: /events/webhooks#security
[webhook payloads]: /schema/webhooks
[Creating]: /events/webhooks#creating-a-subscription
[updating]: /events/webhooks#updating-a-subscription
[`secret`]: /schema/named-type/CreateWebhookSubscription_SubscriptionInput#/field/secret
[`signingAlgorithmCode`]: /schema/named-type/CreateWebhookSubscription_SubscriptionInput#/field/signingAlgorithmCode
